import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 39828 33618"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613604288">
        <path
          d="M34288 30346c-1 8 3 22 5 24-4-4-5-11-6-18 0 13-3 34-6 56 24-48-6 40 2 53-3-4-2-9-4-14-6 38-19 73-31 109-250-325-672-156-908 94-693 586-2304 961-3439 757 7 1 7 1 12 2-1887-280-3546-1323-5061-2414 2 1 1 1 3 2-524-402-1016-859-1418-1381-1256-1874-2837-4325-4759-5936 35-67 68-135 96-205 731-196 1686-409 2328-492 784-100 1581-126 2366-24-7-1-10-1-16-2 1375 172 2682 821 3507 1938 1587 2846 3948 5999 7303 7383-4 0 1 12 16 36 0-7-2-12-5-17 4 7 9 13 8 21 2 2 3 4 4 5v-4c3 6 5 12 8 16-4-5-5-7-8-12 1 7 2 10 3 23zm-1769 767c-57 25-7 1 22-10-8 4-15 6-22 10zm-4452-222c-3-1-6-2-8-3 21 9 40 18 8 3zm-7917-5792c-1-3-2-5-3-8 12 28 31 78 3 8zm-1826-8832c-347 818-742 1629-1141 2427-494-110-1020-46-1461 194-660-697-1131-2195-1192-2821-101-761-71-1540 29-2297 601-3384 2216-7240 2420-10928 3060 3937 3603 8969 1345 13425zm-3433 6756c-4 37-27 182 0 15-870 6779-8492 4224-13035 5864 2574-3772 6839-6340 11399-6950 154-27 1195-120 1644-116 40 395 40 794-8 1187zm19729 6221c-894-443-1810-872-2594-1498-4524-4212-4807-9817-13139-7364-51-291-166-553-330-785 7273-5012 6505-13989-374-18690-3152-2722-1834 1374-2389 3226-443 5073-4522 10824-804 15483-92 170-159 354-200 543C7644 17637-427 24341 18 31246c305 132 557-62 726-302 707-847 1776-1293 2843-1517 5055-276 11833 76 12361-6582 420 169 917 165 1360 26 1903 6263 9872 13668 16601 9564 1034-668 2171-2350 711-3191zM39828 32681c-20-4-38-7-58-11h-3c-112-16-316-23 61 11z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
